var _desc, _defs, _mask, _use, _path, _rect, _rect2, _rect3, _polyline, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect5, _rect6, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _circle, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _polygon, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagenotfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1431px",
    height: "817px",
    viewBox: "0 0 1431 817",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.7352558%",
    y1: "66.0756476%",
    x2: "65.9689911%",
    y2: "24.300287%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.09,752.320004 C166.98,806.320004 484.16,828.140004 854.09,810.890004 C1224.02,793.640004 1466.65,738.890004 1426.4,618.160004 C1386.15,497.430004 1255.79,487.830004 1278.79,347.920004 C1301.79,208.010004 1319.71,70.680004 1185.55,18.920004 C1051.39,-32.839996 877.4,31.920004 770.07,89.420004 C662.74,146.920004 472.5,259.830004 413.07,234.910004 C353.64,209.990004 291.97,139.240004 183.58,231.910004 C-67.47,446.580004 -15.44,696.730004 77.09,752.320004 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.7828396%",
    y1: "52.3145543%",
    x2: "51.0731212%",
    y2: "48.015444%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0003114%",
    y1: "0.00286254079%",
    x2: "50.0003114%",
    y2: "100.002863%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D42A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#643BA3",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E35A0",
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46339F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.21282563e-16%",
    y1: "49.9987552%",
    x2: "100%",
    y2: "49.9987552%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#983D97",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F469E",
    offset: "5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B162B4",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD72C0",
    offset: "39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C178C5",
    offset: "51%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86FBE",
    offset: "64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A055AD",
    offset: "85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B409E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.21282563e-16%",
    y1: "51.6811024%",
    x2: "100%",
    y2: "51.6811024%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09003B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37007B",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26006E",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#170063",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0003114%",
    y1: "101.816963%",
    x2: "50.0003114%",
    y2: "1.48508587%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09003B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37007B",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26006E",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#170063",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "-0.635332253%",
    x2: "0%",
    y2: "-0.635332253%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#663873",
    offset: "2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8CF",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD8FB0",
    offset: "78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#835095",
    offset: "93%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D378B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.21282563e-16%",
    y1: "50.1552795%",
    x2: "100%",
    y2: "50.1552795%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#983D97",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464DC5",
    offset: "51%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B409E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "49.9559859%",
    x2: "0%",
    y2: "49.9559859%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#663873",
    offset: "2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8CF",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD8FB0",
    offset: "78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#835095",
    offset: "93%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D378B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.434652268%",
    y1: "50.3432831%",
    x2: "99.4055995%",
    y2: "49.8952043%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0359732%",
    x2: "99.9939814%",
    y2: "50.0359732%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.9599377%",
    x2: "100.002981%",
    y2: "49.9599377%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0179129%",
    x2: "99.9718668%",
    y2: "50.0179129%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0544766258%",
    y1: "49.9618175%",
    x2: "99.9889046%",
    y2: "49.9618175%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0252582812%",
    y1: "50.0581663%",
    x2: "100.02316%",
    y2: "50.0581663%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0148909%",
    x2: "100.000156%",
    y2: "50.0148909%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0104766894%",
    y1: "49.9886031%",
    x2: "100.027385%",
    y2: "49.9886031%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.9970922%",
    x2: "100.062834%",
    y2: "49.9970922%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0185565335%",
    y1: "50.3092371%",
    x2: "99.9814435%",
    y2: "50.3092371%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0309588805%",
    y1: "50.0918443%",
    x2: "99.9690411%",
    y2: "50.0918443%",
    id: "linearGradient-22"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.9836821%",
    x2: "99.9973512%",
    y2: "49.9836821%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.00853427406%",
    y1: "50.0714378%",
    x2: "99.9400999%",
    y2: "50.0714378%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0190357432%",
    y1: "49.8171685%",
    x2: "99.9665438%",
    y2: "49.8171685%",
    id: "linearGradient-25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0388410734%",
    y1: "49.8869447%",
    x2: "99.9794868%",
    y2: "49.8869447%",
    id: "linearGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0186715474%",
    y1: "49.9655788%",
    x2: "100.018672%",
    y2: "49.9655788%",
    id: "linearGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.0779738%",
    y1: "-89.7814765%",
    x2: "43.8870501%",
    y2: "88.5689519%",
    id: "linearGradient-28"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A9FB",
    offset: "11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A0EF",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3690DA",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497BBE",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625F99",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655C95",
    offset: "59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5F91",
    offset: "64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896886",
    offset: "72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37774",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8C5C",
    offset: "96%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9254",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "92.5793784%",
    y1: "-96.8625545%",
    x2: "3.1394235%",
    y2: "178.692414%",
    id: "linearGradient-29"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A9FB",
    offset: "11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A0EF",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3690DA",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497BBE",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625F99",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655C95",
    offset: "59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5F91",
    offset: "64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896886",
    offset: "72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37774",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8C5C",
    offset: "96%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9254",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.1001916%",
    y1: "11.5211215%",
    x2: "40.8453527%",
    y2: "68.8971361%",
    id: "linearGradient-30"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A9FB",
    offset: "11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A0EF",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3690DA",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497BBE",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625F99",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655C95",
    offset: "59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5F91",
    offset: "64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896886",
    offset: "72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37774",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8C5C",
    offset: "96%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9254",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.5%",
    y1: "-1.13686838e-11%",
    x2: "26.5%",
    y2: "119%",
    id: "linearGradient-31"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A9FB",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A0EF",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3690DA",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497BBE",
    offset: "28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625F99",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655C95",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5F91",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896886",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37774",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8C5C",
    offset: "94%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9254",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.1140351%",
    y1: "41.2150218%",
    x2: "37.5614035%",
    y2: "70.300423%",
    id: "linearGradient-32"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A9FB",
    offset: "11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A0EF",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3690DA",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497BBE",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625F99",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655C95",
    offset: "59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5F91",
    offset: "64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896886",
    offset: "72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37774",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8C5C",
    offset: "96%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9254",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.784339%",
    y1: "-17.9471154%",
    x2: "40.4119551%",
    y2: "80.200367%",
    id: "linearGradient-33"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A9FB",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A0EF",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3690DA",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497BBE",
    offset: "28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625F99",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655C95",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5F91",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896886",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37774",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8C5C",
    offset: "94%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9254",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66.088851%",
    y1: "23.1023049%",
    x2: "44.7854504%",
    y2: "63.1680032%",
    id: "linearGradient-34"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A9FB",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A0EF",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3690DA",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497BBE",
    offset: "28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625F99",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655C95",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5F91",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896886",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37774",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8C5C",
    offset: "94%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9254",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "20.4694843%",
    y1: "123.916345%",
    x2: "85.3318065%",
    y2: "-72.3682673%",
    id: "linearGradient-35"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A9FB",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A0EF",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3690DA",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497BBE",
    offset: "28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625F99",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655C95",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5F91",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896886",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37774",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8C5C",
    offset: "94%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9254",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.3185407%",
    y1: "61.5260884%",
    x2: "77.4940926%",
    y2: "31.2356652%",
    id: "linearGradient-36"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A9FB",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A0EF",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3690DA",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497BBE",
    offset: "28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625F99",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655C95",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5F91",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#896886",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37774",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8C5C",
    offset: "94%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9254",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.8356387%",
    y1: "-40.311596%",
    x2: "46.883156%",
    y2: "82.1736555%",
    id: "linearGradient-37"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A9FB",
    offset: "11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A0EF",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3690DA",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#497BBE",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#625F99",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#655C95",
    offset: "59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5F97",
    offset: "64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89689D",
    offset: "72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B377A6",
    offset: "83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8CB2",
    offset: "96%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF92B6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.5150801%",
    y1: "5.25349598%",
    x2: "41.9625948%",
    y2: "103.742138%",
    id: "linearGradient-38"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88CFDA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89CFD9",
    offset: "1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D9BB",
    offset: "48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DFA7",
    offset: "82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1A0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-6.15188516e-15%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-39"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7700BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.00681454223%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-40"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7137FF",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6243FF",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4957FF",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2672FF",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.2720018%",
    y1: "54.2975083%",
    x2: "65.3291953%",
    y2: "37.1835957%",
    id: "linearGradient-41"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7231FA",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682DEB",
    offset: "29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5625D2",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1BAF",
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F0D83",
    offset: "84%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000057",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.1815818%",
    y1: "58.0199663%",
    x2: "57.3080588%",
    y2: "43.9945411%",
    id: "linearGradient-42"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5FF",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE9FF",
    offset: "37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD9FF",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C3FF",
    offset: "63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA9FF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378AFF",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.99101292e-13%",
    y1: "49.988861%",
    x2: "100%",
    y2: "49.988861%",
    id: "linearGradient-43"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BA8FF",
    offset: "24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#169CFF",
    offset: "49%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D87FF",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006BFF",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "27.2069703%",
    y1: "71.8685316%",
    x2: "119.913247%",
    y2: "16.6095811%",
    id: "linearGradient-44"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5FF",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE9FF",
    offset: "37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD9FF",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C3FF",
    offset: "63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA9FF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378AFF",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0032235%",
    x2: "100.024335%",
    y2: "50.0032235%",
    id: "linearGradient-45"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BA8FF",
    offset: "24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#169CFF",
    offset: "49%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D87FF",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006BFF",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "70.7104595%",
    y1: "122.210162%",
    x2: "27.2790998%",
    y2: "17.6717997%",
    id: "linearGradient-46"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7231FA",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682DEB",
    offset: "29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5625D2",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1BAF",
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F0D83",
    offset: "84%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000057",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0032235%",
    x2: "100.024335%",
    y2: "50.0032235%",
    id: "linearGradient-47"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CA9FB",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9FEF",
    offset: "27%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#188EDA",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1476BD",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5898",
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08326B",
    offset: "84%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010737",
    offset: "98%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00002E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.5561936%",
    y1: "67.2987087%",
    x2: "76.2100082%",
    y2: "10.4092937%",
    id: "linearGradient-48"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7231FA",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682DEB",
    offset: "29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5625D2",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1BAF",
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F0D83",
    offset: "84%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000057",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "71.7356678%",
    y1: "20.7180737%",
    x2: "-0.0320254528%",
    y2: "108.420525%",
    id: "linearGradient-49"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7633FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7231FA",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#682DEB",
    offset: "29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5625D2",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1BAF",
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F0D83",
    offset: "84%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000057",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0607422227%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-50"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BA8FF",
    offset: "24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#169CFF",
    offset: "49%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D87FF",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006BFF",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0934819973%",
    y1: "49.9322476%",
    x2: "100.091711%",
    y2: "49.9322476%",
    id: "linearGradient-51"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5FF",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE9FF",
    offset: "37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD9FF",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C3FF",
    offset: "63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA9FF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378AFF",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "62.2192716%",
    y1: "-1.69076243%",
    x2: "34.6968259%",
    y2: "114.764346%",
    id: "linearGradient-52"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5FF",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE9FF",
    offset: "37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD9FF",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C3FF",
    offset: "63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA9FF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378AFF",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.7176104%",
    y1: "98.8944135%",
    x2: "64.5995815%",
    y2: "11.3957911%",
    id: "linearGradient-53"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311842",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#190C4B",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000054",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.7647235%",
    y1: "40.0263161%",
    x2: "45.5322229%",
    y2: "58.3721805%",
    id: "linearGradient-54"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CAAFB",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BA3EF",
    offset: "28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1898DA",
    offset: "42%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1488BD",
    offset: "56%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F7499",
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#085B6B",
    offset: "84%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#013E37",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003B31",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0820479%",
    x2: "99.9993638%",
    y2: "50.0820479%",
    id: "linearGradient-55"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BA8FF",
    offset: "24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#169CFF",
    offset: "49%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D87FF",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006BFF",
    offset: "99%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0812128%",
    x2: "100.045341%",
    y2: "50.0812128%",
    id: "linearGradient-56"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270006",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.9080461%",
    x2: "100.035638%",
    y2: "49.9080461%",
    id: "linearGradient-57"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#270006",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00008B",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "34.9624155%",
    y1: "102.022583%",
    x2: "74.6632373%",
    y2: "-81.5952425%",
    id: "linearGradient-58"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5FF",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE9FF",
    offset: "37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD9FF",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C3FF",
    offset: "63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA9FF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378AFF",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.536%",
    y1: "68.0383376%",
    x2: "70.688%",
    y2: "-1.32759596%",
    id: "linearGradient-59"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5FF",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE9FF",
    offset: "37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD9FF",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C3FF",
    offset: "63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA9FF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378AFF",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-60"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5FF",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE9FF",
    offset: "37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD9FF",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C3FF",
    offset: "63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA9FF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378AFF",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "70.8798244%",
    y1: "53.2666171%",
    x2: "38.7964149%",
    y2: "47.571893%",
    id: "linearGradient-61"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFDFF",
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF5FF",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE9FF",
    offset: "37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD9FF",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C3FF",
    offset: "63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA9FF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378AFF",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AFF",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page-not-found",
    transform: "translate(-64.000000, -68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(64.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-88.000000, 386.830004)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1351.98,237.49 C1351.98,237.49 932.98,60.49 843.98,30.49 C814.3,20.49 692.98,85.49 587.11,123.04 C507.86,58.92 425.25,-0.96 394.53,0.1 C301.59,3.4 90.24,221.61 90.24,221.61 L763.24,274.51 C763.24,274.51 750.8,263.14 730.4,245.03 L1351.98,237.49 Z",
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "roof",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0.000000, 182.000000)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero",
    transform: "translate(803.755000, 279.870000) rotate(180.000000) translate(-803.755000, -279.870000) ",
    x: 1,
    y: 105.2,
    width: 1605.51,
    height: 349.34
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(803.755000, 306.025000) rotate(180.000000) translate(-803.755000, -306.025000) ",
    x: 1,
    y: 105.19,
    width: 1605.51,
    height: 401.67
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero",
    transform: "translate(803.755000, 72.170000) rotate(180.000000) translate(-803.755000, -72.170000) ",
    x: 1,
    y: 39.15,
    width: 1605.51,
    height: 66.04
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-8)",
    fillRule: "nonzero",
    opacity: 0.27,
    transform: "translate(803.755000, 72.000000) rotate(180.000000) translate(-803.755000, -72.000000) ",
    x: 1,
    y: 38.81,
    width: 1605.51,
    height: 66.38
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero",
    points: "1606.51 0.08 1606.51 6.25 1 6.25 1 0.08"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-10)",
    fillRule: "nonzero",
    transform: "translate(803.755000, 108.420000) rotate(180.000000) translate(-803.755000, -108.420000) ",
    x: 1,
    y: 105.2,
    width: 1605.51,
    height: 6.44
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.43,2.49 L1606.56,2.49 L1606.56,40.02 L1396.43,40.02 L1396.43,2.49 Z M1606.51,9.9 L1403.84,9.9 L1403.84,32.61 L1606.51,32.61 L1606.51,9.9 Z",
    id: "Shape",
    fill: "#09003B",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.67,2.49 L1403.84,2.49 L1403.84,40.02 L1147.67,40.02 L1147.67,2.49 Z M1396.43,9.9 L1155.08,9.9 L1155.08,32.61 L1396.43,32.61 L1396.43,9.9 Z",
    id: "Shape",
    fill: "#09003B",
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M898.9,2.49 L1155.08,2.49 L1155.08,40.02 L898.9,40.02 L898.9,2.49 Z M1147.67,9.9 L906.31,9.9 L906.31,32.61 L1147.67,32.61 L1147.67,9.9 Z",
    id: "Shape",
    fill: "#09003B",
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M650.13,2.49 L906.31,2.49 L906.31,40.02 L650.13,40.02 L650.13,2.49 Z M898.9,9.9 L657.54,9.9 L657.54,32.61 L898.9,32.61 L898.9,9.9 Z",
    id: "Shape",
    fill: "#09003B",
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M401.37,2.49 L657.54,2.49 L657.54,40.02 L401.37,40.02 L401.37,2.49 Z M650.13,9.9 L408.78,9.9 L408.78,32.61 L650.13,32.61 L650.13,9.9 Z",
    id: "Shape",
    fill: "#09003B",
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.6,2.49 L408.78,2.49 L408.78,40.02 L152.6,40.02 L152.6,2.49 Z M401.37,9.9 L159.98,9.9 L159.98,32.61 L401.37,32.61 L401.37,9.9 Z",
    id: "Shape",
    fill: "#09003B",
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.98,2.49 L159.98,2.49 L159.98,40.02 L0.98,40.02 L0.98,2.49 Z M152.58,9.9 L1.19,9.9 L1.19,32.61 L152.6,32.61 L152.58,9.9 Z",
    id: "Shape",
    fill: "#09003B",
    fillRule: "nonzero"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-11)",
    fillRule: "nonzero",
    transform: "translate(1395.180000, 21.240000) rotate(180.000000) translate(-1395.180000, -21.240000) ",
    x: 1393.92,
    y: 9.88,
    width: 2.52,
    height: 22.72
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFEB99",
    fillRule: "nonzero",
    transform: "translate(410.690000, 21.240000) rotate(180.000000) translate(-410.690000, -21.240000) ",
    x: 409.43,
    y: 9.88,
    width: 2.52,
    height: 22.72
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M1034,731.176416 C1034.64731,752.071986 929.069654,772.251136 798.180579,776.290946 C667.291503,780.330756 560.663378,766.698884 560,745.823215 C559.342781,724.947546 664.950446,704.748495 795.819513,700.708685 C926.688579,696.668875 1033.34672,710.310697 1034,731.176416 Z",
    id: "Path",
    fill: "url(#linearGradient-12)",
    fillRule: "nonzero",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(889.000000, 621.000000)",
    fillRule: "nonzero"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.23,127.24 C0.23,127.24 1.12,135.24 15.97,133.64 C27.24,132.4 40.67,131.24 48.8,132.5 C56.93,133.76 77.43,133.99 87.91,125.87 C98.39,117.75 96.73,107.21 92,105.87 C87.27,104.53 73.47,106.87 68.12,110.48 C62.77,114.09 51.73,119.57 40.93,118.56 C30.13,117.55 1.46,111.28 0.23,127.24 Z",
    id: "Path",
    fill: "url(#linearGradient-13)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2,104.72 C97.2,104.72 97.2,109.48 102.65,109.3 C108.1,109.12 112.08,104.14 111.43,101.22 C110.78,98.3 101.03,97.39 97.2,104.72 Z",
    id: "Path",
    fill: "url(#linearGradient-14)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.3,114.09 C100.3,114.09 100.75,116.89 104.94,117.32 C109.13,117.75 109.94,114.51 109.62,113.04 C109.3,111.57 102.3,110.06 100.3,114.09 Z",
    id: "Path",
    fill: "url(#linearGradient-15)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.64,123.58 C105.28,124.96 103.3,125.65 101.21,125.11 C99.12,124.57 97.7,123.02 98.06,121.64 C98.42,120.26 100.4,119.58 102.49,120.11 C104.58,120.64 105.98,122.2 105.64,123.58 Z",
    id: "Path",
    fill: "url(#linearGradient-16)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9,129.18 C98.55,130.56 96.72,131.28 94.81,130.8 C92.9,130.32 91.65,128.8 92.01,127.41 C92.37,126.02 94.19,125.31 96.09,125.8 C97.99,126.29 99.25,127.8 98.9,129.18 Z",
    id: "Path",
    fill: "url(#linearGradient-17)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M244.7,95.02 C244.7,95.02 244.7,103.79 259.64,103.11 C270.97,102.59 284.46,103.42 292.39,105.57 C300.32,107.72 320.69,110.2 332,103.28 C343.31,96.36 342.81,85.69 338.26,83.84 C333.71,81.99 319.73,82.84 314.02,85.84 C308.31,88.84 296.73,93.08 286.1,90.84 C275.47,88.6 247.68,79.29 244.7,95.02 Z",
    id: "Path",
    fill: "url(#linearGradient-18)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M343.55,83.27 C343.55,83.27 343.06,88.01 348.47,88.43 C353.88,88.85 358.4,84.33 358.08,81.36 C357.76,78.39 348.16,76.4 343.55,83.27 Z",
    id: "Path",
    fill: "url(#linearGradient-19)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M345.61,92.92 C345.61,92.92 345.75,95.76 349.86,96.65 C353.97,97.54 355.14,94.4 354.98,92.91 C354.82,91.42 348.04,89.14 345.61,92.92 Z",
    id: "Path",
    fill: "url(#linearGradient-20)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M349.87,102.95 C349.37,104.28 347.32,104.74 345.3,103.95 C343.28,103.16 342.05,101.49 342.55,100.16 C343.05,98.83 345.1,98.36 347.12,99.16 C349.14,99.96 350.37,101.61 349.87,102.95 Z",
    id: "Path",
    fill: "url(#linearGradient-21)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M342.56,107.77 C342.06,109.11 340.16,109.62 338.32,108.93 C336.48,108.24 335.4,106.6 335.9,105.26 C336.4,103.92 338.3,103.41 340.14,104.1 C341.98,104.79 343.06,106.49 342.56,107.77 Z",
    id: "Path",
    fill: "url(#linearGradient-22)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.54,35.11 C113.54,35.11 113.54,25.82 126.39,23.99 C137.62,22.4 150.56,18.35 157.85,14.55 C165.14,10.75 184.49,3.95 197.02,8.28 C209.55,12.61 211.36,23.13 207.31,25.92 C203.26,28.71 189.43,30.92 183.22,29.2 C177.01,27.48 164.77,25.85 154.87,30.28 C144.97,34.71 119.82,49.83 113.54,35.11 Z",
    id: "Path",
    fill: "url(#linearGradient-23)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M212.61,25.34 C212.61,25.34 211.11,20.81 216.3,19.24 C221.49,17.67 226.88,21.11 227.21,24.09 C227.54,27.07 218.59,31.05 212.61,25.34 Z",
    id: "Path",
    fill: "url(#linearGradient-24)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M212.54,15.49 C212.54,15.49 212.07,12.69 215.9,10.93 C219.73,9.17 221.54,12 221.7,13.49 C221.86,14.98 215.73,18.64 212.54,15.49 Z",
    id: "Path",
    fill: "url(#linearGradient-25)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M214.55,4.76 C213.77,3.57 211.67,3.56 209.86,4.76 C208.05,5.96 207.22,7.86 207.99,9.05 C208.76,10.24 210.87,10.26 212.68,9.05 C214.49,7.84 215.33,5.96 214.55,4.76 Z",
    id: "Path",
    fill: "url(#linearGradient-26)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M206.37,1.62 C205.6,0.43 203.63,0.33 201.98,1.4 C200.33,2.47 199.63,4.31 200.41,5.5 C201.19,6.69 203.15,6.8 204.8,5.72 C206.45,4.64 207.15,2.82 206.37,1.62 Z",
    id: "Path",
    fill: "url(#linearGradient-27)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M700.156548,655.68237 C700.156548,655.68237 693.75112,675.921373 692.685209,680.087051 C691.619298,684.252729 691.828495,685.461475 693.093642,690.236521 C694.358789,695.011567 700.505211,718.936745 702.627071,724.321159 C704.338492,728.726227 707.673306,732.302844 711.941341,734.310795 C714.880067,735.569489 725.449522,734.840245 727.830389,734.200909 C729.274661,733.814489 730.692247,733.333965 732.07411,732.762401 C732.07411,732.762401 731.844989,728.317013 729.354542,726.76862 C726.864096,725.220226 719.681648,723.861635 719.681648,723.861635 C719.681648,723.861635 714.919915,714.421429 714.700755,709.73629 C714.481596,705.051151 717.689291,686.760128 719.263253,684.312667 C720.837215,681.865206 739.186825,661.606224 745.163896,653.904215 C748.402725,649.811629 751.35515,645.499117 754,640.997605 C754,640.997605 744.576151,638.050663 737.592939,638 C730.609727,637.950766 720.657903,640.528093 717.01189,642.855678 C713.365876,645.183263 700.156548,655.68237 700.156548,655.68237 Z",
    id: "Path",
    fill: "url(#linearGradient-28)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M700.156548,655.68237 C700.156548,655.68237 693.75112,675.921373 692.685209,680.087051 C691.619298,684.252729 691.828495,685.461475 693.093642,690.236521 C694.358789,695.011567 700.505211,718.936745 702.627071,724.321159 C704.338492,728.726227 707.673306,732.302844 711.941341,734.310795 C714.880067,735.569489 725.449522,734.840245 727.830389,734.200909 C729.274661,733.814489 730.692247,733.333965 732.07411,732.762401 C732.07411,732.762401 731.844989,728.317013 729.354542,726.76862 C726.864096,725.220226 719.681648,723.861635 719.681648,723.861635 C719.681648,723.861635 714.919915,714.421429 714.700755,709.73629 C714.481596,705.051151 717.689291,686.760128 719.263253,684.312667 C720.837215,681.865206 739.186825,661.606224 745.163896,653.904215 C748.402725,649.811629 751.35515,645.499117 754,640.997605 C754,640.997605 744.576151,638.050663 737.592939,638 C730.609727,637.950766 720.657903,640.528093 717.01189,642.855678 C713.365876,645.183263 700.156548,655.68237 700.156548,655.68237 Z",
    id: "Path",
    fill: "url(#linearGradient-28)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M828,655.409218 C828,655.409218 832.230336,653.71929 840.057965,648.209524 C844.890519,644.804562 849.470945,641.058406 853.763852,637 L862.375248,639.089911 C862.375248,639.089911 878.54297,658.169101 880.462196,662.348924 C882.381422,666.528746 882.471857,668.748652 880.914369,672.758482 C879.356882,676.768312 872.775243,685.75793 870.805775,689.117787 C868.836308,692.477645 866.635729,697.277441 865.32945,696.987453 C864.02317,696.697466 856.929068,690.117745 857.290806,686.317906 C857.583241,683.856751 858.293359,681.462849 859.390902,679.238207 C860.005575,677.080192 860.747076,674.959965 861.611577,672.888476 C862.265484,671.449699 863.045573,670.071087 863.942784,668.768651 C863.942784,668.768651 849.101439,660.209015 842.449461,658.039107 C837.744957,656.635758 832.899092,655.753782 828,655.409218 Z",
    id: "Path",
    fill: "url(#linearGradient-29)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M828,655.409218 C828,655.409218 832.230336,653.71929 840.057965,648.209524 C844.890519,644.804562 849.470945,641.058406 853.763852,637 L862.375248,639.089911 C862.375248,639.089911 878.54297,658.169101 880.462196,662.348924 C882.381422,666.528746 882.471857,668.748652 880.914369,672.758482 C879.356882,676.768312 872.775243,685.75793 870.805775,689.117787 C868.836308,692.477645 866.635729,697.277441 865.32945,696.987453 C864.02317,696.697466 856.929068,690.117745 857.290806,686.317906 C857.583241,683.856751 858.293359,681.462849 859.390902,679.238207 C860.005575,677.080192 860.747076,674.959965 861.611577,672.888476 C862.265484,671.449699 863.045573,670.071087 863.942784,668.768651 C863.942784,668.768651 849.101439,660.209015 842.449461,658.039107 C837.744957,656.635758 832.899092,655.753782 828,655.409218 Z",
    id: "Path",
    fill: "url(#linearGradient-29)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M933.446451,700.536674 C933.446451,700.536674 942.510563,703.060785 949.363672,702.269496 C952.693595,701.949821 955.998899,701.411115 959.258161,700.65687 C959.258161,700.65687 969.2627,699.525026 970.493258,698.152792 C971.723816,696.780557 970.493258,691.822481 969.142645,689.8693 C967.792032,687.916119 966.781574,686.593966 966.781574,686.593966 C966.781574,686.593966 954.015783,661.322807 954.355937,657.316282 C954.696091,653.309756 958.357753,643.163231 956.246795,639.347015 C954.135837,635.5308 948.883454,622.719935 940.939851,614.857129 C932.996247,606.994323 920.510583,596.697553 914.717955,592.821239 C908.925327,588.944926 895.809377,579.920228 888.335987,576.975432 C880.862597,574.030635 860.323279,564.555203 856.981763,562.271484 C853.640247,559.987764 844.085913,551.544012 833.971324,551.544012 C823.856736,551.544012 799.955893,559.26659 788.170546,561.560325 C776.3852,563.854061 755.855887,565.506753 743.680363,565.326459 C731.50484,565.146165 709.464841,566.748776 698.739976,569.332985 C688.015111,571.917193 676.840041,577.185774 673.948729,576.65491 C671.057418,576.124045 652.008776,564.575236 649.32756,561.349983 C646.646343,558.12473 630.759136,533.224175 628.538129,526.763652 C626.317121,520.30313 619.213899,499.128644 618.813717,495.853309 C618.413536,492.577975 615.682296,486.838627 614.681843,489.843521 C613.681389,492.848415 617.8933,512.650667 621.785065,528.336214 C625.676831,544.02176 630.118846,553.96796 637.40215,564.935823 C644.685454,575.903686 659.562203,590.647699 659.562203,590.647699 C659.562203,590.647699 651.558572,611.942382 646.266171,625.474421 C640.97377,639.006461 639.973316,642.852725 630.819163,655.01253 C621.665011,667.172334 607.668661,688.617261 606.928325,692.23315 C606.187989,695.849039 605.727781,711.424407 606.177985,721.350573 C606.628189,731.27674 609.009269,746.87214 609.249378,748.334522 C609.489487,749.796904 612.610903,752.621504 617.112946,753.713282 C621.614988,754.80506 630.729123,752.491292 632.239808,751.579807 L633.750493,750.668323 C633.750493,750.668323 632.539944,744.197784 629.078374,743.426528 C625.616803,742.655272 621.855097,741.944114 621.855097,741.944114 C621.855097,741.944114 624.856458,719.297229 626.507207,713.357555 C628.157956,707.417881 635.681369,694.036087 639.383048,692.263199 C643.084728,690.490312 666.915539,678.440687 679.041039,671.128778 C687.983637,665.846981 696.274379,659.529995 703.742245,652.308125 C708.914592,647.299968 718.879112,639.006461 732.195153,637.994813 C745.511194,636.983165 760.788124,640.82943 766.630775,643.00297 C772.473425,645.17651 776.775377,647.009495 776.775377,647.009495 C776.775377,647.009495 772.973652,651.296477 773.083702,652.949169 C773.193752,654.601861 773.603938,665.359381 774.344274,678.070083 C775.08461,690.780785 776.785382,714.489399 777.635767,718.676218 C778.486153,722.863037 780.637129,728.021438 783.458409,728.892857 C786.279689,729.764277 802.827195,727.230149 803.907686,725.717686 C804.988176,724.205223 803.257391,720.709529 800.826288,719.056838 C798.523534,717.654983 796.149225,716.374489 793.713061,715.22059 C793.713061,715.22059 793.372907,689.618892 795.193733,684.49054 C797.014559,679.362188 798.705326,677.419023 799.095503,674.694585 C799.48568,671.970148 803.097318,663.536412 805.038199,663.225907 C806.979079,662.915401 827.208256,656.274585 831.210071,654.281339 C835.211887,652.288092 853.590224,636.883002 853.590224,636.883002 C858.934277,637.588528 864.234898,638.591715 869.467427,639.887896 C874.190886,641.075549 878.767752,642.785495 883.113618,644.9862 C883.697406,648.565553 884.824258,652.034534 886.455134,655.272954 C888.459494,658.953856 891.024779,662.299411 894.058583,665.189104 L933.446451,700.536674 Z",
    id: "Path",
    fill: "url(#linearGradient-30)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M773.375,653 C773.441087,652.662591 773.524531,652.328814 773.625,652 C773.472267,652.312042 773.387079,652.652794 773.375,653 L773.375,653 Z",
    id: "Path",
    fill: "url(#linearGradient-31)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786,638.019621 C786,638.019621 777.33,637.349986 749.33,629.354346 C721.33,621.358706 712.67,624.686891 712.67,624.686891 C712.67,624.686891 710.5,632.022891 700,646.015261 C688,662.00654 672,674 672,674 L675.53,673.260403 C676.83,672.510812 678.06,671.801199 679.19,671.12157 C688.132038,665.851903 696.422405,659.548619 703.89,652.341811 C709.06,647.344536 719.02,639.069048 732.33,638.059599 C745.64,637.050149 760.91,640.888056 766.75,643.056874 C771.38,644.80592 775.03,646.285113 776.34,646.834814 C779.165227,643.491451 782.412299,640.528349 786,638.019621 L786,638.019621 Z",
    id: "Path",
    fill: "url(#linearGradient-32)",
    fillRule: "nonzero",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.895388,583 C664.895388,583 676.287167,580.401165 683,574.243926 C678.912185,575.673285 675.726094,576.712819 674.35347,576.472927 C671.437896,575.95316 652.381465,564.418332 649.696331,561.199775 C647.011198,557.981218 631.100781,533.132359 628.876529,526.68525 C626.652276,520.238141 619.538677,499.107615 619.137911,495.839081 C618.737145,492.570546 616.001915,486.843114 615,489.84177 C615,489.84177 621.442316,527.334959 634.467217,548.995247 C642.400222,562.120642 652.719733,573.653127 664.895388,583 L664.895388,583 Z",
    id: "Path",
    fill: "url(#linearGradient-33)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.630198,645.6415 C883.216098,649.213478 884.347027,652.675311 885.983802,655.907058 C887.995414,659.580376 890.569979,662.919037 893.614758,665.802775 L933.145117,701.117493 C933.145117,701.117493 942.24202,703.636403 949.11992,702.846745 C952.444428,702.525917 955.744655,701.991702 959,701.247437 C927.361656,694.250465 901.014777,654.597624 898.845979,648.660194 C896.175144,641.323369 885.461684,635.325964 885.461684,635.325964 L861.363929,626 L853,637.574991 C858.363385,638.279063 863.683182,639.280183 868.934641,640.573693 C873.674365,641.752504 878.267762,643.452212 882.630198,645.6415 Z",
    id: "Path",
    fill: "url(#linearGradient-34)",
    fillRule: "nonzero",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914,592.105853 C907.883548,587.966118 895.590678,579.576119 888.454818,576.752658 C885.91629,575.747868 881.868638,573.979437 877.461194,572 C880.01971,582.520154 874.542887,601.138918 874.023189,608.463839 C873.353577,617.84858 887.345461,615.839 895.340823,610.47342 C900.307942,607.127468 906.304464,598.134595 914,592.105853 Z",
    id: "Path",
    fill: "url(#linearGradient-35)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867,567.611507 C862.49732,565.457159 858.816956,563.603418 857.543369,562.731659 C854.17388,560.447048 844.616967,552 834.478416,552 C824.339865,552 800.382399,559.725592 788.569131,562.020223 C776.755864,564.314854 756.177915,565.968191 743.973546,565.787827 C731.769178,565.607463 709.676964,567.210698 698.92669,569.795916 C696.921042,570.266866 694.915394,570.797938 693,571.439233 C698.134459,579.946402 709.045185,593.273298 727.477091,595.066918 C754.8943,597.742318 758.233704,587.05074 772.273241,593.062874 C786.312777,599.075008 793.001614,624.466253 813.719959,616.450074 C830.80808,609.756565 853.842949,575.81807 867,567.611507 Z",
    id: "Path",
    fill: "url(#linearGradient-36)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M970.460814,698.547302 C971.76682,697.203224 970.460814,692.346882 969.083385,690.433777 C967.705957,688.520673 966.675436,687.225648 966.675436,687.225648 L966.552998,687 C958.635334,690.531885 959.002648,701 959.002648,701 C959.002648,701 969.165011,699.891381 970.460814,698.547302 Z",
    id: "Path",
    fill: "#270006",
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M949,649 C946.896921,650.144082 944.653839,651.037792 942.321288,651.660996 C940.179762,652.14037 938.069149,652.737013 936,653.447943 C936,653.447943 942.208955,657.973579 945.578947,656.808179 C948.94894,655.642779 949,649 949,649 Z",
    id: "Path",
    fill: "#270006",
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M909.32933,628.393321 C908.656372,628.704873 901.042896,637.518786 899.024019,645.116641 C897.005142,652.714495 893.91154,666.02079 894.001937,672.523187 C894.092335,679.025583 898.180309,687.397293 900.400069,690.291714 C902.619829,693.186135 919.252964,706.020077 925.510478,706 C931.767991,705.979876 933.545808,698.663424 932.862805,695.769003 C932.179802,692.874582 928.744698,662.844968 928.162137,654.664209 C927.579575,646.483451 928.875272,635.991175 929.417657,634.644466 C929.960042,633.297756 932.069316,629.448579 930.733443,628.915925 C924.121043,625.222005 916.113923,625.026502 909.32933,628.393321 L909.32933,628.393321 Z",
    id: "Path",
    fill: "url(#linearGradient-37)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M909.32933,628.393321 C908.656372,628.704873 901.042896,637.518786 899.024019,645.116641 C897.005142,652.714495 893.91154,666.02079 894.001937,672.523187 C894.092335,679.025583 898.180309,687.397293 900.400069,690.291714 C902.619829,693.186135 919.252964,706.020077 925.510478,706 C931.767991,705.979876 933.545808,698.663424 932.862805,695.769003 C932.179802,692.874582 928.744698,662.844968 928.162137,654.664209 C927.579575,646.483451 928.875272,635.991175 929.417657,634.644466 C929.960042,633.297756 932.069316,629.448579 930.733443,628.915925 C924.121043,625.222005 916.113923,625.026502 909.32933,628.393321 L909.32933,628.393321 Z",
    id: "Path",
    fill: "url(#linearGradient-37)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904,586 C898.494235,582.482759 892.438893,578.886032 888.202152,577.226768 C880.747886,574.305669 860.223674,564.906487 856.886241,562.641146 C853.548809,560.375804 844.006149,552 833.90392,552 C823.801691,552 799.930054,559.660432 788.159108,561.93571 C776.388163,564.210988 755.883935,565.85038 743.72329,565.671537 C731.562644,565.492694 709.549577,567.082408 698.837817,569.645821 C691.693313,571.354763 684.398924,574.255991 679.452729,575.85564 C674.076864,578.985389 670,581.817066 670,581.817066 C670,581.817066 692.152959,572.050263 725.287471,569.894214 C750.598002,568.185272 783.882398,567.181765 795.873174,564.538866 C807.863951,561.895967 827.848578,555.258913 836.511914,557.911748 C845.17525,560.564582 849.831668,561.220339 863.151422,567.181765 C873.213682,571.682642 894.287471,581.429573 904,586 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "overlay"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.7,
    cx: 352,
    cy: 258,
    r: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.89194,178.864434 C1020.43281,196.502801 1046.87231,201.837481 1069.88047,192.380666 C1092.88864,182.92385 1107.93383,160.538135 1108,135.663013 C1108.06574,110.787892 1093.13946,88.3227155 1070.18176,78.7440349 C1047.22407,69.1653542 1020.75666,74.359766 1003.12251,91.904876 C979.04949,115.856337 978.946274,154.785665 1002.89194,178.864434 Z",
    id: "moon",
    fill: "url(#linearGradient-38)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-39)",
    fillRule: "nonzero",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    },
    cx: 329,
    cy: 737,
    rx: 231,
    ry: 38
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M241.983066,545 C241.983066,545 319.084126,485.902959 340.45838,465.77034 C361.832635,445.637722 380.471464,415.6089 391.642782,391.253635 C402.814099,366.898369 428.091826,321.119676 437.316399,309.432351 C446.540972,297.745025 464.530887,282.155254 464.530887,282.155254 L483,269.977621 C483,269.977621 472.797063,236.866868 466.028383,221.277097 C461.797109,211.672952 456.588178,202.53216 450.484378,194 L428.571025,215.923741 C428.571025,215.923741 406.218406,205.207024 402.334901,203.255801 C398.451395,201.304578 355.203721,207.158247 339.160551,207.158247 C323.11738,207.158247 314.381989,207.638548 306.604995,210.56038 C298.828001,213.482211 248.292514,240.759308 231.290947,248.063886 C214.28938,255.368465 200.672152,263.653658 201.650516,266.075175 C202.62888,268.496693 219.141265,301.147158 223.513953,300.166543 C227.88664,299.185929 267.730008,277.2822 283.773178,267.536091 C299.816348,257.789982 309.52012,253.897543 309.52012,253.897543 L350.341852,261.202121 C350.341852,261.202121 338.681352,296.764411 314.401956,326.473032 C290.12256,356.181652 237.630345,390.763327 218.67205,397.577598 C199.713755,404.39187 190,404.882177 190,404.882177 C190,404.882177 210.415857,450.66087 216.735289,478.428274 C223.054721,506.195678 235.703567,538.816124 240.54547,544.659787",
    id: "Path",
    fill: "url(#linearGradient-40)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286,354.15086 C287.995123,353.475806 312.604966,366.241376 343.858568,364.901344 C375.11217,363.561312 414.685436,345.082973 414.685436,345.082973 L421,334 L297.970738,341.727855 L286,354.15086 Z",
    id: "Path",
    fill: "url(#linearGradient-41)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M339.577757,207.29456 C323.54246,207.29456 314.795934,207.773128 307.017917,210.68442 C299.239899,213.595711 248.69776,240.774411 231.693955,248.05264 C214.69015,255.330868 201.07113,263.586174 202.049623,265.998957 C202.149469,266.268152 300.398114,214.343474 312.878888,212.349439 C325.359661,210.355404 389.051542,204.831926 400.384084,209.358386 C411.716625,213.884846 426.703538,219.328562 426.703538,219.328562 L429,216.018464 C429,216.018464 406.644439,205.340405 402.760423,203.396221 C398.876406,201.452036 355.623039,207.29456 339.577757,207.29456 Z",
    id: "Path",
    fill: "url(#linearGradient-42)",
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M203.524343,269.04215 C203.128196,268.084692 191,283.756756 191,283.756756 C191,283.756756 198.242382,295.205929 203.189142,299.781567 C206.133095,302.523073 209.610337,304.639124 213.407706,306 L220,297.493748 C220,297.493748 208.135902,280.491323 203.524343,269.04215 Z",
    id: "Path",
    fill: "url(#linearGradient-43)",
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M198.076554,294 C198.076554,294 188.879822,302.525579 185.250842,303.005893 C181.621861,303.486208 166.618761,300.814459 163.715577,301.054616 C160.812392,301.294774 150.402687,310.560837 147.022266,313.472743 C143.641846,316.384648 143.383343,318.836252 144.844878,319.316567 C146.306413,319.796881 148.712476,318.836252 148.712476,318.836252 C148.712476,318.836252 150.402687,321.998321 153.305871,322.238479 C156.209055,322.478636 168.796149,318.105774 176.292728,318.836252 C183.789307,319.56673 196.376401,322.238479 199.766764,323.699435 C203.157126,325.160391 208.714935,333.445812 211.86668,334.906768 C215.018424,336.367724 219.611819,337.098202 217.43443,332.225014 C215.257042,327.351825 210.156585,319.576737 210.156585,315.674183 C210.156585,311.771629 211.856737,304.95717 211.856737,304.95717 C211.856737,304.95717 203.395744,301.30478 198.076554,294 Z",
    id: "Path",
    fill: "url(#linearGradient-44)",
    fillRule: "nonzero"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M371,428 C371,428 389.128731,427.350461 399.165883,426.001418 C404.410514,425.402943 409.605429,424.427788 414.710496,423.083489 C415.759553,418.672962 417.390198,414.421943 419.559458,410.44246 C423.12135,403.957063 445.141223,364.075366 453.552077,351.424344 C458.406607,344.082329 463.704438,337.044205 469.415964,330.3493 C469.415964,330.3493 480.101639,307.365612 484.641304,300.190703 C489.18097,293.015795 494,285.331249 494,285.331249 L480.031798,273 C480.031798,273 460.286746,283.052866 445.719906,299.591129 C431.153066,316.129392 399.744565,372.879118 392.940055,388.438076 C386.741299,402.21524 379.402342,415.44872 371,428 Z",
    id: "Path",
    fill: "url(#linearGradient-45)",
    fillRule: "nonzero"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M474,366.193067 C474,366.193067 478.54823,397.256428 482.77588,409.881216 C487.00353,422.506004 489.598225,432.208941 494.146455,435.120819 C498.694686,438.032698 579,439 579,439 C579,439 571.847057,417.001357 572.498235,403.728377 C573.149413,390.455397 572.818815,383.67431 572.818815,383.67431 C572.818815,383.67431 550.067646,383.026118 535.441179,382.048843 C520.814712,381.071569 519.181757,381.051625 517.228222,379.785157 C515.274688,378.518689 513.331171,368.137643 511.708234,361.665694 C510.085297,355.193745 506.498807,323.482193 505.206469,314.437419 C503.91413,305.392646 502.491556,292 502.491556,292 C502.491556,292 490.569984,313.131063 484.719397,327.401262 C478.86881,341.671461 474,366.193067 474,366.193067 Z",
    id: "Path",
    fill: "url(#linearGradient-46)",
    fillRule: "nonzero"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M371,428 C371,428 389.128731,427.350461 399.165883,426.001418 C404.410514,425.402943 409.605429,424.427788 414.710496,423.083489 C415.759553,418.672962 417.390198,414.421943 419.559458,410.44246 C423.12135,403.957063 445.141223,364.075366 453.552077,351.424344 C458.406607,344.082329 463.704438,337.044205 469.415964,330.3493 C469.415964,330.3493 480.101639,307.365612 484.641304,300.190703 C489.18097,293.015795 494,285.331249 494,285.331249 L480.031798,273 C480.031798,273 460.286746,283.052866 445.719906,299.591129 C431.153066,316.129392 399.744565,372.879118 392.940055,388.438076 C386.741299,402.21524 379.402342,415.44872 371,428 Z",
    id: "Path",
    fill: "url(#linearGradient-47)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M417,340 C417,340 435.515176,336.061885 448.525841,330.154712 C461.536505,324.247539 467.541427,319.157525 467.541427,319.157525 L473.216079,319.492264 L478,312 L467.281214,312.984529 L422.834783,331.326301 L417,340 Z",
    id: "Path",
    fill: "url(#linearGradient-48)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M494.095029,284.798911 C494.095029,284.798911 472.56052,316.051598 467.342775,339.80966 C462.12503,363.567723 464.407165,389.974488 465.06064,395.161531 C465.714115,400.348574 467.011011,416 467.011011,416 C467.011011,416 473.86747,362.283503 480.392165,342.097176 C486.916859,321.91085 499.966249,295.865272 503.51512,294.239931 C507.063991,292.614591 527,293.908843 527,293.908843 C527,293.908843 526.678289,287.076394 522.75744,281.869285 C518.836591,276.662176 517.539695,276 517.539695,276 C517.539695,276 508.07939,288.370646 503.836831,287.036262 C500.63023,286.123975 497.378651,285.377201 494.095029,284.798911 L494.095029,284.798911 Z",
    id: "Path",
    fill: "url(#linearGradient-49)",
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M466.597395,413.712487 C466.597395,413.712487 466.279384,457.188585 467.243356,467.567654 C468.207329,477.946722 473.04707,491.90547 474.666942,500.664683 C476.286814,509.423897 471.437136,516.893227 472.083097,515.913315 C472.729058,514.933403 445.966387,480.226518 436.306783,465.297857 C426.647178,450.369197 418.567694,434.800594 418.249682,431.880857 C417.93167,428.961119 418.567694,426.691322 417.255895,424.741497 C415.944097,422.791672 415,422.791672 415,422.791672 C415,422.791672 415.238509,420.281897 419.183841,412.092632 C424.520475,401.033625 434.895606,381.945338 444.336578,366.666709 C460.783744,340.059097 469.489314,330 469.489314,330 C469.489314,330 463.03964,361.797146 464.331562,379.645544 C465.623484,397.493943 467.243356,412.432602 467.243356,412.432602 L466.597395,413.712487 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M268,335.93116 C269.935901,335.279888 295.521733,313.176731 299.403515,310.571644 C303.285297,307.966558 324.989347,305.040845 353.479031,309.569688 C381.968715,314.098531 408.522497,324.518877 444.147076,310.22096 C461.220929,303.357559 460.013485,300.792551 460.013485,300.792551 L466.160471,291.033496 L465.841147,280.633189 L469.074302,279 C469.074302,279 475.770126,290.02152 480.360408,293.087506 C483.35407,295.091419 490,290.742928 490,290.742928 L478.145098,311.513483 L467.457725,312.51544 C467.457725,312.51544 445.115027,328.767172 409.500427,338.846853 C373.885827,348.926533 347.631411,356.401128 326.276622,354.777958 C304.921832,353.154789 297.138311,348.926533 286.131613,345.028923 C279.717521,342.805504 273.621641,339.74682 268,335.93116 L268,335.93116 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M573.596103,384.33 L585.401249,384 C585.401249,384 584.663427,399.9 585.320392,408.34 C585.977356,416.78 590,430.73 590,430.73 L577.871425,433 C573.856408,417.539634 572.308179,401.553408 573.282781,385.62",
    id: "Path",
    fill: "url(#linearGradient-50)",
    fillRule: "nonzero"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M589.600178,430 C591.173158,427.781557 592.224967,425.262599 592.683029,422.616941 C592.988829,419.75452 593.073521,416.874372 592.936414,414 L586,414.738306 L589.600178,430 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M584.55965,383.825195 C583.539741,394.298047 583.915038,404.859279 585.675775,415.23408 L592.223041,414.509413 L595.621241,409.674986 C596.379072,411.404099 597.357064,413.02891 598.531137,414.509413 C600.03951,416.559419 602.160396,418.081401 604.590098,418.857419 L604.350929,420.84281 C604.350929,420.84281 609.682416,423.741481 613.319786,423.979727 C616.957156,424.217974 621.292104,422.292145 623.753557,421.567477 C626.21501,420.84281 629.573348,412.385044 631.725874,409.486373 C633.8784,406.587703 634.147466,402.71619 635.851548,399.817519 C637.555631,396.918848 639.728088,393.781931 638.761444,389.195678 C637.794801,384.609424 626.384421,380.976159 622.996186,379.268723 C619.607951,377.561287 609.65252,368.150533 607.470098,365.738283 C605.287676,363.326033 601.650306,360.179189 598.501241,363.316106 C595.352175,366.453024 592.193144,378.782302 590.977366,380.469884 C589.761588,382.157467 584.4301,384.817891 584.4301,384.817891",
    id: "Path",
    fill: "url(#linearGradient-51)",
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M608,379 L615.790498,358.204933 C615.790498,358.204933 612.140265,345.731913 619.190716,322.253287 C626.241167,298.774661 637.931915,286.29159 646.702476,285.065395 C655.473037,283.839199 660.813378,299.990805 653.702923,322.253287 C646.592469,344.515768 639.101989,353.310202 633.991663,357.431023 C628.881336,361.551843 621.090837,361.833265 621.090837,361.833265 L617.730622,377.512484 L608,379 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M596.386285,410 C596.386285,410 593.591613,421.113975 594.051012,422.562761 C594.51041,424.011547 600.051899,427.2862 601.975629,425.460333 C603.665431,423.800907 604.736408,421.576572 605,419.178952 C605,419.178952 597.544351,414.346358 596.386285,410 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M645.655822,326.623181 C638.480007,343.861809 628.111562,355.997883 622.496587,353.726746 C616.881613,351.455609 618.1688,335.627688 625.354751,318.379055 C632.540702,301.130423 642.899012,288.994349 648.503851,291.275491 C654.10869,293.556632 652.841773,309.374549 645.655822,326.623181 Z",
    id: "Path",
    fill: "url(#linearGradient-52)",
    fillRule: "nonzero"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M187.018998,687.543913 C192.530942,678.130927 239.27743,618.411984 250.311322,605.097761 C261.345214,591.783538 261.025101,587.252101 262.315556,573.287671 C263.606011,559.323242 263.986146,527.843256 263.986146,527.843256 C263.986146,527.843256 320.466067,483.049047 337.672136,468.124313 C354.878205,453.199579 370.783815,427.871545 370.783815,427.871545 C370.783815,427.871545 377.596218,427.551444 386.689425,427.221339 C395.782632,426.891234 414.609273,423 414.609273,423 L415.899728,424.000317 C417.200187,425.000635 417.530303,427.241345 417.530303,430.162272 C417.530303,433.083198 422.071905,441.525876 424.992935,448.338037 C427.913966,455.150198 465.247134,505.146057 471.089194,514.228938 C476.931255,523.311819 517.175449,572.657471 520.746709,580.780048 C524.317969,588.902624 520.076473,595.694779 510.323033,608.018688 C500.569592,620.342597 471.059184,666.777326 469.418605,670.718576 C467.778026,674.659826 473.97021,676.890534 475.270669,679.161254 C476.571128,681.431974 475.910895,694.416093 475.910895,697.657121 C475.910895,700.898149 472.989865,704.479285 471.699409,706.099799 C470.408954,707.720313 470.699057,710.971344 470.699057,710.971344 C470.699057,710.971344 454.473333,722.65505 446.690588,724.925771 C438.907843,727.196491 429.484519,734.658858 427.533831,734.988963 C425.583143,735.319067 422.672117,728.166799 422.342,723.985472 C422.011884,719.804146 425.593147,715.542794 427.863948,709.98103 C430.134749,704.419266 431.75532,688.564237 439.868182,658.694762 C447.981043,628.825288 465.507225,588.912627 465.507225,587.932316 C465.507225,586.952005 458.364706,583.390876 450.251844,578.849435 C442.138983,574.307995 428.504174,564.244803 412.238437,552.230992 C395.972699,540.217181 358.359433,509.057297 354.458056,507.756885 C350.55668,506.456472 343.754281,510.687814 339.532792,517.179874 C335.311303,523.671933 324.277411,559.693359 319.725806,573.657788 C315.1742,587.622218 308.041685,600.926438 295.387221,616.501378 C282.732758,632.076319 240.527871,671.678881 236.306382,677.850838 C232.084893,684.022796 228.84375,695.706502 229.163863,700.568044 C229.483976,705.429586 224.942374,711.571535 223.00169,712.571852 C221.061005,713.572169 212.93814,717.113292 204.175049,715.81288 C195.411958,714.512467 183.717834,708.350513 182.097262,708.030411 C182.097262,708.030411 180.146574,699.907835 181.447033,696.666807 C182.747491,693.425779 187.018998,687.543913 187.018998,687.543913 Z",
    id: "Path",
    fill: "url(#linearGradient-53)",
    fillRule: "nonzero"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M327,552.854347 C342.621528,553.325075 358.256525,552.654448 373.780754,550.847795 C396.690507,547.91823 404,545.470237 404,545.470237 C404,545.470237 371.46775,517.689531 364.368531,513.13466 C357.269311,508.579788 354.295449,505.319141 348.76827,507.927658 C343.241092,510.536175 340.647724,516.385273 336.752666,523.548662 C332.857607,530.712051 327,552.854347 327,552.854347 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M204.318269,715.155191 C195.606637,713.865868 184.004374,707.699107 182.395155,707.379275 C182.395155,707.379275 182.266021,706.839559 182.097152,706 C181.034274,708.048924 177.13043,715.524997 172.729913,723.270928 C167.564522,732.34616 163.700412,743.380364 164.018282,746.94849 C164.336152,750.516615 172.729913,757.942715 183.3587,753.754914 C193.987486,749.567114 199.152877,742.400879 205.599683,736.563945 C212.046489,730.727011 214.301381,722.941101 214.947055,721.002119 C215.493838,718.849636 215.846252,716.651855 216,714.435569 C212.188668,715.431306 208.221861,715.675671 204.318269,715.155191 L204.318269,715.155191 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M408.03201,177.379308 C406.540818,178.088785 457.391467,192.947843 510.003524,207.856863 C562.615581,222.765883 598.984654,226.663013 599.965438,226.99277 C600.946222,227.322528 580.800118,216.290652 571.702845,210.45495 C562.605573,204.619247 550.275717,198.134023 550.275717,198.134023 C550.275717,198.134023 549.274917,182.245724 548.974677,171.213848 C548.674437,160.181973 546.052341,148.520561 542.479485,145.922474 C538.906629,143.324387 509.353004,134.930569 500.26574,133.601547 C491.178476,132.272526 485.974316,133.011982 483.382244,137.16892 C480.790172,141.325859 473.314195,160.151995 469.371043,166.357425 C465.427891,172.562855 462.265363,178.97813 461.294587,178.97813 C460.323811,178.97813 414.857466,174.131699 408.03201,177.379308 Z",
    id: "Path",
    fill: "url(#linearGradient-54)",
    fillRule: "nonzero"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M468.143165,167 C468.143165,167 498.656685,175.949787 516.514597,177.830325 C534.37251,179.710863 548.328694,182.300295 549.299124,183.580243 C550.269553,184.86019 549.949412,197 549.949412,197 C549.949412,197 524.93833,194.125041 502.548409,189.645225 C488.444636,186.773573 474.561496,182.937555 461,178.16508 C461,178.16508 462.300576,175.309813 468.143165,167 Z",
    id: "Path",
    fill: "url(#linearGradient-55)",
    fillRule: "nonzero"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M408,177 C408,177 422.254364,185.85869 433.226933,190.253925 C444.199501,194.649161 449.416459,195 449.416459,195 L452,190.565782 L408,177 Z",
    id: "Path",
    fill: "url(#linearGradient-56)",
    fillRule: "nonzero"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M544.29722,216 L543,222.158936 C543,222.158936 568.25588,227.997928 579.571632,227.997928 C586.097996,228.041714 592.610576,227.39152 599,226.058263 C599,226.058263 555.303635,219.229442 544.29722,216 Z",
    id: "Path",
    fill: "url(#linearGradient-57)",
    fillRule: "nonzero"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M544.746233,216.536147 C546.383024,216.735337 539.566387,229.782276 539.566387,233.019112 C539.566387,236.255948 538.917658,246.912608 540.56443,251.762883 C542.211202,256.613157 544.127446,265.985042 539.266973,266.951113 C534.406501,267.917184 530.524112,265.009012 527.609825,266.303746 C524.695537,267.598481 519.835065,273.73353 516.27205,276.970366 C512.709034,280.207202 507.848562,287.308322 503.966172,286.989618 C500.083783,286.670915 494.255208,284.997719 490.991606,282.786711 C487.728003,280.575703 480.302559,272.438795 480.302559,272.438795 L483.546201,269.530623 C483.546201,269.530623 474.473985,239.801528 468.326036,225.260665 C462.178088,210.719801 451,193.908173 451,193.908173 L452.127789,191 C452.127789,191 531.462273,214.912749 544.746233,216.536147 Z",
    id: "Path",
    fill: "url(#linearGradient-58)",
    fillRule: "nonzero"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M455.34576,200.148207 C457.613548,199.818271 459.881335,195.609097 464.746589,195.929034 C469.611842,196.248971 474.796784,199.498334 474.796784,205.987062 C474.796784,212.475789 469.93153,229.702411 469.93153,229.702411 L473.817739,240.080376 L484.227583,242 C484.227583,242 485.526316,223.503627 488.113791,216.005097 C490.701267,208.506568 492,203.007646 492,203.007646 C492,203.007646 466.025341,195.549108 459.591618,193.269555 C453.157895,190.990002 452.128899,191 452.128899,191 L451,193.919428 L455.34576,200.148207 Z",
    id: "Path",
    fill: "#270006",
    fillRule: "nonzero"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M525.052379,722.742573 C522.62172,716.405788 516.804079,718.357878 507.589492,717.867353 C498.374906,717.376828 494.499799,718.868425 485.773337,715.865209 C477.046875,712.861994 470.741109,711 470.741109,711 C470.741109,711 454.583208,722.69252 446.832993,724.964953 C441.722634,726.466561 435.924916,730.200559 432,732.683217 C432.159387,733.614214 432.926439,736.887719 435.845222,737.308169 C439.232205,737.798695 466.875964,737.798695 475.602426,737.798695 C484.328888,737.798695 506.145044,738.799766 515.847754,736.33713 C525.550464,733.874493 527.473075,729.079358 525.052379,722.742573 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M485,135.526726 C485,135.526726 522.296,142.095088 531.872,146.642415 C541.448,151.189743 548,181 548,181 C548,181 547.0928,147.501355 542.5064,145.045798 C537.92,142.590241 504.152,133 497.096,133 C492.931394,132.977851 488.809138,133.838799 485,135.526726 Z",
    id: "Path",
    fill: "url(#linearGradient-59)",
    fillRule: "nonzero"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M450.053823,195 C450.053823,195 461.62815,221.08 467.11918,237.5 C473.473516,256.5 475.651858,268 475.651858,268 C475.651858,268 457.753311,279.67 451.057668,287 C444.362025,294.33 436,307 436,307 C436,307 454.480777,286.81 465.733874,280.24 C476.986971,273.67 483,269.24 483,269.24 C483,269.24 468.624947,217.5 450.053823,195 Z",
    id: "Path",
    fill: "url(#linearGradient-60)",
    fillRule: "nonzero"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-61)",
    fillRule: "nonzero",
    points: "518 383 573 384.57346 572.43662 389"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 827,
    cy: 142,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 952,
    cy: 251,
    r: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 1237,
    cy: 162,
    r: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 744,
    cy: 277,
    r: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 612,
    cy: 256,
    r: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 1125,
    cy: 363,
    r: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagenotfound);
export default __webpack_public_path__ + "static/media/pagenotfound.2e8782e5c68b5d71d62326c275b67dbd.svg";
export { ForwardRef as ReactComponent };